import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import styled, { css } from 'styled-components';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { BodyS } from '@sorare/core/src/atoms/typography';

const flex = css`
  display: flex;
  align-items: center;
  gap: var(--half-unit);
`;
const Root = styled(BodyS)`
  ${flex}
`;

type OrderConfirmedProps = {
  color?: 'var(--c-green-600)' | 'var(--c-white)';
};
export const OrderConfirmed = ({
  color = 'var(--c-green-600)',
}: OrderConfirmedProps) => (
  <Root bold color={color}>
    <FontAwesomeIcon icon={faCircleCheck} />
    <FormattedMessage
      id="ClubShop.Item.OrderConfirmed"
      defaultMessage="Order confirmed"
    />
  </Root>
);
